// extracted by mini-css-extract-plugin
export default {"card":"cardStyle_card__AdawZ","title":"cardStyle_title__0VQ9J"};